<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-7">
                              <div class="maheading_2">
                                <h5 class="modal-title">Add {{ unitType }}</h5>
                              </div>  
                            </div>
                            <div class="col-5 text-right">
                              <div class="col-12 p-0">
                                {{ usedLicense }}/{{ totalLicense }} Mentee {{ unitType }}s Used
                              </div>
                              <div class="col-12 p-0">
                                Subscription Expires: {{ accountExpire }}
                              </div>
                            </div>
                          </div>


                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow">
                           
                                 <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                          <div class="col-6">
                                            <span><label class="form-label">Unit Type</label></span>
                                            <span><label id="popover-reactive-1" class="help-txt">?</label></span>
                                          </div>
                                          <div class="col-2">
                                            <label class="form-label text-center" style="width: 100%;">Quantity</label>
                                          </div>
                                          <div class="col-4">
                                            <label class="form-label text-center" style="width: 100%;">Price</label>
                                          </div>
                                        </div>
                                        <div class="row row_data_border" v-for="(pitem, sindex) in subscriptions" :key="sindex">
                                          <div class="col-6">
                                            <label :for="'subscription_plan_' + sindex">{{ pitem.name }}(s)</label>
                                          </div>
                                          <div class="col-3" >
                                            <b-form-select class="col-12 ma-input-field" v-model="unit" name="unit" :options="qty_options" placeholder="Qty" v-validate="'required'"   @change="getPriceforSubscription">           
                                            </b-form-select>
                                          </div>

                                        <div class="col-3" v-if="unitType == 'Seat' && type == 'monthly'">
                                            <label for=""  style="width: 100%; text-align: center;"><span class="dollarsign" >$</span>&nbsp;{{ originalPrice }}/monthly</label>
                                        </div>
                                        <div class="col-3" v-else-if="unitType == 'Seat' && type == 'yearly'">
                                            <label for=""  style="width: 100%; text-align: center;"><span class="dollarsign" >$</span>&nbsp;{{ originalPrice }}/annually</label>
                                        </div>
                                        <div class="col-3" v-else>
                                            <label for=""  style="width: 100%; text-align: center;"><span class="dollarsign" >$</span>&nbsp;{{ pitem.price }}/{{ pitem.duration }}</label>
                                        </div>

                                        <div v-if="verrors.firstByRule('unit', 'required')" class="margin-bottom-5 validate-warning-msg" style="padding-left: 15px;">Quantity is required</div>
                                        </div>                                        

                                        <div class="row">
                                          <div class="col-9 text-right pr-0" style="padding-top: 8px;">
                                            Prorated
                                          </div>
                                          <div class="col-3 col-sm-3 pl-0" style="text-align: right;  padding-right: 30px;">
                                            <button type="button" class="btn btn-sm btn-blue totalBtn text-center" style="cursor: default;">
                                              Total: <span class="total_price">${{ subscriptionTotal }}</span>
                                            </button>
                                          </div>
                                        </div>

                                    </div>
                                </div>

                          </div>

                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow" v-if="type != 'monthly'">
                            <div class="row">
                                <div class="col-8">
                                  Payment Method
                                </div>
                                <div class="col-4 text-right pr-4">
                                    &nbsp;
                                </div>
                            </div>
                            <div class="row pb-2" v-if="cardName != ''">
                              <div class="col-3 seat_qty pt-1">
                                  {{ cardName }}
                              </div>
                              <div class="col-4  pt-1">
                                  {{ cardNo }}
                              </div>
                              <div class="col-2 pt-1">
                                  {{ cardExpire }}
                              </div>
                              <div class="col-3 text-right pr-2">
                                  <button type="submit" class="btn btn-md ma-blue-btn" @click="openPaymentListsModal">Edit</button>
                              </div>
                            </div>
                            <div class="row pb-2" v-else>
                              <div class="col-12 seat_qty text-center">
                                <i>No Payment Method found!</i>
                              </div>
                              <div class="col-12 text-center pt-2">
                                <button type="submit" class="btn btn-md ma-blue-btn" @click="openNewPaymentMethodModal()">Add New Payment Method</button>
                              </div>
                            </div>
                            <div class="clear"></div>
                          </div>




                                <div class="text-center m-4">
                                    <button :disabled="process_payment_disable" type="button" class="btn btn-sm ma-blue-btn text-center" @click="onSubmit">
                                        Process Payment
                                    </button>
                                </div>
                                <div style="height: 20px;"></div>
                            
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <NewPaymentMethod
          :isModalVisible="isNewPaymentMethodModalVisible"
          ref="NewPaymentMethodModal"
          @close="isNewPaymentMethodModalVisible = false">
        </NewPaymentMethod>

        <PaymentLists
          :isModalVisible="isPaymentListsModalVisible"
          ref="PaymentListsModal"
          @close="isPaymentListsModalVisible = false">
        </PaymentLists>

        <AddLicenseSuccessModal 
            :isAddLicenseSuccessModalVisible="isAddLicenseSuccessModalVisible"
            :paymentMethod="paymentMethod"
            :invoice_filename="invoice_filename"            
            :unitType="unitType"
            landingPage="adminconsole"
            ref="add_license_success"
            @close="close"
        />

        <AddLicenseFailedModal
            :isAddLicenseFailedModalVisible="isAddLicenseFailedModalVisible"
            :unitType="unitType"
            landingPage="managelicense"
            @close="close"
        />

        <CreateInvoiceConfirmModal
            :isCreateInvoiceModalVisible="isCreateInvoiceModalVisible"
            landingPage="managelicense"            
            @close="close"
        />
        
    <b-popover
      target="popover-reactive-1"
      triggers="click"
      :show.sync="popoverShow"
      placement="right"
      container="my-container"
      ref="popover"
     >
      <template #title>
        <b-button @click="onClose" class="close" aria-label="Close">
          <span class="d-inline-block" aria-hidden="true">&times;</span>
        </b-button>
        <label>Mentor Mentee Unit Types</label>
      </template>

      <div>
        <div class="license-term-label"> {{ unitType }}s Terms: </div>
        <div class="license-term-content"> This is where we will show  terms. </div>
        <div class="license-term-label"> {{ unitType }} Pricing: </div>
        <div class="license-term-content" v-if="licenseDetails.length > 0 && unitType == 'Seat'"> Mentee licenses start at ${{ licenseDetails[0].startingSeatPrice}}</div>
        <div class="license-term-content" v-else-if="licenseDetails.length > 0"> Mentee licenses start at ${{ licenseDetails[0].priceFormatted}}</div>
        <div style="margin-top: 20px;">
        <div class="license-term-content"> Purchasing more than one {{ unitType }}? </div>
        <div class="license-term-content"> Purchasing 2-10 {{ unitType }}s? </div>
        </div>
        <div style="margin-bottom: 30px;">
        <div class="license-term-label"> Additional Info: </div>
        <div class="license-term-content" v-if="licenseDetails.length > 0"> {{ unitType }}s have an expiration of {{licenseDetails[0].validityDuration}} months. </div>
        </div>
      </div>
    </b-popover>
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)

import AddLicenseSuccessModal from './add_license_success_modal.vue';
import AddLicenseFailedModal from './add_license_failed_modal.vue';
import CreateInvoiceConfirmModal from './create_invoice_confirm_modal.vue';

import NewPaymentMethod from './new_payment_method.vue';
import PaymentLists from './payment_method_lists.vue';


Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible', 'totalLicense'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            newAccountId: '',
            invoice_filename: '',
            close_url: '',
            country_options: [],
            state_options: [],
            isAddLicenseSuccessModalVisible: false,
            isCCRequired: 1,
            paymentMethod: 'credit_card',
            isAddLicenseFailedModalVisible: false,
            isCreateInvoiceModalVisible: false,
            unit: 1,
            activeLicense: 0,
            popoverShow: false,
            licenseDetails: [],
            qty_options: [
              { value: '', text: 'Select' },
              { value: 1, text: 1 },
              { value: 2, text: 2 },
              { value: 3, text: 3 },
              { value: 4, text: 4 },
              { value: 5, text: 5 },
              { value: 6, text: 6 },
              { value: 7, text: 7 },
              { value: 8, text: 8 },
              { value: 9, text: 9 },
              { value: 10, text: 10 },
              { value: 11, text: 11 },
              { value: 12, text: 12 },
              { value: 13, text: 13 },
              { value: 14, text: 14 },
              { value: 15, text: 15 },
              { value: 16, text: 16 },
              { value: 17, text: 17 },
              { value: 18, text: 18 },
              { value: 19, text: 19 },
              { value: 20, text: 20 },
            ],
            seat_qty_options: [
              { value: '', text: 'Select' },
              { value: 5, text: 5 },
              { value: 10, text: 10 },
              { value: 15, text: 15 },
              { value: 20, text: 20 },
            ],
            licenseType: '',
            process_payment_disable: false,
            description: '',
            unitType: '',
            billing_name: '',
            billing_address: '',
            billing_address2: '',
            billing_city: '',
            billing_state: '',
            billing_country: '',
            billing_zip: '',
            billing_phone: '',
            payment_method: 'credit_card',
            invoice_filename: '',
            isNewPaymentMethodModalVisible: false,
            isPaymentListsModalVisible: false,
            cardName: '',
            cardNo: '',
            cardExpire: '',
            totalLicense: '',
            usedLicense: '',
            accountExpire: '',
            type: '',
            originalPrice: '',
            seatMaxQty: '',
        }
    },
    components: {
      AddLicenseSuccessModal,
      AddLicenseFailedModal,
      CreateInvoiceConfirmModal,        
      NewPaymentMethod,
      PaymentLists,
    },
    methods: {       
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },

        openNewPaymentMethodModal() {
          this.isNewPaymentMethodModalVisible = true;
          this.$refs.NewPaymentMethodModal.loadInitialData();
        },
        openPaymentListsModal() {
          this.isPaymentListsModalVisible = true;
          this.$refs.PaymentListsModal.loadInitialData();
        },
        closePaymentMethod() {
          this.isNewPaymentMethodModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        closePaymentMethodLists() { 
          this.isPaymentListsModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        getPrimaryPaymentDetails() {

          axios('/desktop/get-payment-details/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {        
            this.cardName = resp.data.cardName;
            if(this.cardName == '') {
              this.process_payment_disable = true;
            }
            else {
              this.process_payment_disable = false;
            }
            this.cardNo = resp.data.cardNo;
            this.cardExpire = resp.data.cardExpire;
            this.billing_name = resp.data.billing_name;
            this.billing_address = resp.data.billing_address;
            this.billing_address2 = resp.data.billing_address2;
            this.billing_city = resp.data.billing_city;
            this.billing_state = resp.data.billing_state;
            this.billing_country = resp.data.billing_country;
            this.billing_zip = resp.data.billing_zip;
            this.billing_phone = resp.data.billing_phone;
          })
          .catch(() => {
          });      

        },

        setSubscriptionTotal(item) {
          this.subscriptionId = item.id;
          this.subscriptionTotal = item.price;
        },
        onSubmit() {
          this.processPayment();
        },
        roundToTwo(num) {
          return +(Math.round(num + "e+2")  + "e-2");
        },

        getPriceforSubscription: function() {
          axios('/getsubscriptionPrice',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.unit,
                accountId: this.$store.state.user_accountid,
              }
            }
          )
          .then(response => {
              this.subscriptions[0].price = response.data;
              if(this.unitType == 'Seat') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else {
                this.subscriptionTotal = parseFloat(this.subscriptions[0].price * this.unit).toFixed(2);
              }
              this.subscriptionPrice = response.data;
          })
          .catch(error => {

          });
        },
        doValidate() {
          var flag = 1;
          if(this.unitType == 'Seat') {
            var qty = parseInt(this.unit + this.totalLicense);
            if(qty > this.seatMaxQty) {
              alert("Please upgrade bundle");
              flag = 0;
              return false;
            }
          }
          return flag;
        },
        processPayment() {
            var flag = this.doValidate();
            if(flag == 1) {
            this.process_payment_disable = true;
            this.loading = true;
            axios('/orders-new', 
            {
                method: 'POST',
                data: {
                        "subscription_id": this.subscriptionId,
                        "subscription_price": this.subscriptionPrice,
                        "units": this.unit,
                        "description": this.description,
                        "subscription_total": this.subscriptionTotal,
                        "account_id": this.$store.state.user_accountid,
                        "billing_name": this.billing_name,
                        "billing_address": this.billing_address,
                        "billing_address2": this.billing_address2,
                        "billing_city": this.billing_city,
                        "billing_state": this.billing_state,
                        "billing_country": this.billing_country,
                        "billing_zip": this.billing_zip,
                        "billing_phone": this.billing_phone,
                        "payment_method": this.paymentMethod,
                },
            })
            .then((response) => {
                this.process_payment_disable = false;
                this.loading = false;
                this.verrors.clear();
                this.invoice_filename = response.data.invoice_filename;
                if (response.data.msg != 'failed') {
                    this.isAddLicenseSuccessModalVisible = true;
                } else {
                    this.isAddLicenseFailedModalVisible = true;
                }
            })
            .catch(error => {
                this.process_payment_disable = false;
                console.log(error)
            });
            }
        },
        getSubscriptionLists() {
            axios.get('/active-subscriptions/' + this.$store.state.user_accountid + '/Single')
            .then((resp) => {
                this.loading = false;
                this.seatMaxQty = resp.data.seatMaxQty;
                this.maxAdditionalSeatLimit = resp.data.maxAdditionalSeatLimit;
                this.subscriptions = resp.data.subscriptions;
                this.type = resp.data.type;
                this.totalLicense = resp.data.totalLicense;
                this.usedLicense = resp.data.usedLicense;
                this.accountExpire = resp.data.accountExpire;
                this.unitType = this.subscriptions[0].name;
                this.licenseType = this.subscriptions[0].licenseType;
                this.unit = this.subscriptions[0].minQty;
                this.description = this.subscriptions[0].description;
                this.originalPrice = this.subscriptions[0].originalPrice;
                if(this.maxAdditionalSeatLimit != '') {
                  this.qty_options = [];
                  var qty =  { value: '', text: 0 };
                  this.qty_options.push(qty);
                  for(var i=1; i <= this.maxAdditionalSeatLimit; i++) {
                      var qty = {value: i, text: i};
                      this.qty_options.push(qty);
                  }
                }
                if((this.unit > 1)) {
                    this.qty_options = [];
                    var qty =  { value: '', text: 'Select' };
                    this.qty_options.push(qty);
                    for(var i=this.unit; i < 21; i++) {
                        var qty = {value: i, text: i};
                        this.qty_options.push(qty);
                    }
                    this.subscriptionTotal = this.subscriptions[0].price;
                }
                else if(this.subscriptions[0].name == 'Seat') {
                    this.subscriptionTotal = this.subscriptions[0].price;
                }
                else {
                    this.subscriptionTotal = parseFloat(this.subscriptions[0].price * this.unit).toFixed(2);
                }
                this.subscriptionId = this.subscriptions[0].id;
                this.subscriptionPrice = this.subscriptions[0].price;
                this.getLicenseTermDetails();
            })
            .catch(error => {

            });
        },
        getLicenseTermDetails() {
            axios.get('/desktop/get-license-term-details/' + this.subscriptionId)
            .then((resp) => {              
                this.licenseDetails = resp.data;                            
            })
            .catch(error => {

            });
        },
        loadInitialData() {
            this.verrors.clear();
            this.getSubscriptionLists();
            this.getPrimaryPaymentDetails();
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0) {
                    return 'No Renew Subscription';
                }
            }
        },
        hide() { 
            this.$parent.closeLicenseModal();
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'managelicense'});              
                window.open(routeData.href, '_self');                
            }
        },
        choosePaymentMode(event) {
            if(event.target.value == 'credit_card') {
                this.isCCRequired = 1;
            }
            else {
                this.isCCRequired = 0;                
            }
        },
        onClose() {
          this.popoverShow = false
        },
    },
    created() {
      axios('/desktop/get-account-active-license/'+ this.$store.state.user_accountid,
      {
        method: 'GET'        
      })
      .then(resp => {        
        this.activeLicense = resp.data[0].active_license;
      })
      .catch(() => {
      });      
    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.totalBtn, .totalBtn.btn-blue {
  color: #707070; 
  background-color: #FFF !important;
  border: 1px solid #707070 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 8px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 32px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; margin-top: 10px; font-size: 14px;border-bottom: 2px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.custom-select { height: 34px; }
.license-term-content { font-size: 12px;}
.license-term-label { color: #00ACEE; font-weight: bold; font-size: 13px; padding-top: 10px;}
.help-txt {
    display: inline-block;
    height: 15px;
    width: 15px;
    line-height: 15px;
    -moz-border-radius: 8px;
    border-radius:8px;
    border: 1px solid #00ACEE;
    background-color: white;
    text-align: center;
    font-size: 0.75em;
    cursor: pointer;
}
.btn-secondary:hover { background-color: #FFF !important;}
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}

</style>

<style>
.popover-body { padding-right: 50px !important;}
.popover-header div { text-align: center;}
button.close { font-size: 30px;margin-top: -7px;}
.popover .popover-header { font-size: 14px; font-weight: bold;}
.popover { width: 340px !important; max-width: 340px !important;}
.bs-popover-right > .arrow::before {
    border-right-color: rgba(0, 172, 238, 0.90) !important;
}

</style>


// WEBPACK FOOTER //
// src/components/manager/add_license.vue